// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__eEEAJ","title":"Banner_title__NwvDC","form":"Banner_form__+iBUL","label":"Banner_label__ynvHS","sum":"Banner_sum__pMFj6"};